// The dashboard's tiles, shared by Results' summary and Overview: a label, a
// big number, an optional hint, and the change against the previous window.

import { Card } from "@pej/kore/components";
import type { ReactNode } from "react";

/** The big number in a tile. */
export const TILE_VALUE = "mt-1 text-2xl font-semibold tabular-nums";

export function StatTile({ label, hint, children }: { label: string; hint?: string; children: ReactNode }) {
    return (
        <Card className="p-4">
            <p className="text-sm text-muted-foreground">{label}</p>
            {children}
            {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
        </Card>
    );
}

export function DeltaLine({
    testId,
    delta,
    unit,
    digits,
}: {
    testId: string;
    delta: number;
    unit: string;
    digits: number;
}) {
    const tone = delta > 0 ? "text-kore-success-text" : delta < 0 ? "text-kore-danger-text" : "text-muted-foreground";
    const sign = delta > 0 ? "+" : delta < 0 ? "−" : "";
    return (
        <p data-testid={testId} className={`mt-1 text-sm font-semibold tabular-nums ${tone}`}>
            {`${sign}${Math.abs(delta).toFixed(digits)} ${unit}`}
        </p>
    );
}

/** In place of a change when there's no earlier window to compare with. */
export function NoEarlierData() {
    return (
        <p data-testid="tile-no-earlier-data" className="mt-1 text-sm text-muted-foreground">
            No earlier data
        </p>
    );
}
